import { BoundingBox } from '@egr/wcf/modules/core/mdl';
import { ajax } from '@egr/wcf/modules/utils/async';
import { Matrix, Vector2, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { downloadContent } from "./MATZloader";
import { Util } from './utils/Util';
import { addElements, contains, removeElement } from "@egr/wcf/modules/utils/array";
import { ERR_INVALID_ARGUMENT } from "@egr/wcf/modules/utils/error";
import { ZipDocumentContainer } from "@egr/wcf/modules/core/io";
import { RoomWizard } from "./RoomWizard";
import { InsertElements } from "@egr/wcf/modules/core/cmd";
import { VECTOR3_Y } from "@egr/wcf/modules/core/utils/MathUtils";
import { SearchArticleParameterSet } from "@egr/wcf/modules/eaiws/catalog";
import { getFileExtension } from "@egr/wcf/modules/utils/string";
export class OPLeoxImporter {
    static importOPL_EOX(pRoomManager, pFile, pEaiwsSession) {
        if (pFile == null)
            return;
        let tFileExt = getFileExtension(pFile.name).toLocaleLowerCase();
        if (tFileExt === ".zip") {
            this.getStructurefromZIP(pRoomManager, pFile, pEaiwsSession);
        }
    }
    static async getStructurefromZIP(pRoomManager, pZipData, pEaiwsSession) {
        this.mOpeningMaterial = {};
        this.mOpeningMaterial.category = "veneer";
        this.mOpeningMaterial.value = "veneer_tauari_09";
        this.mOpeningMaterial.rotation = 90;
        this.mOpeningMaterial.loadMatId = "";
        await pRoomManager.checkMaterial(this.mOpeningMaterial);
        let tContainer = await ZipDocumentContainer.LoadContainer(pZipData);
        // meta XML
        await this.loadFromContainer_metaXML(tContainer).then((pSceneOBX) => {
            OPLeoxImporter.importMetaXML(pRoomManager, pSceneOBX);
        });
        // scene OBX
        await this.loadFromContainer_sceneOBX(tContainer).then((pSceneOBX) => {
            OPLeoxImporter.importSceneOBX(pRoomManager, pSceneOBX);
        });
        // room structure
        await this.loadFromContainer_structureXML(tContainer).then((pXMLstructure) => {
            OPLeoxImporter.importRoomPlanning(pRoomManager, pXMLstructure, pEaiwsSession);
        });
    }
    static async loadFromContainer_metaXML(pContainer) {
        try {
            if (pContainer == null) {
                throw new Error(ERR_INVALID_ARGUMENT);
            }
            let tFiles = await pContainer.listFiles();
            try {
                let tcatFile = "meta.xml"; //"meta.xml";
                if (contains(tFiles, tcatFile)) {
                    let t_cat = await pContainer.getFile(tcatFile, false);
                    console.log(tcatFile + " loaded!");
                    return (Promise.resolve(t_cat));
                }
            }
            catch (error) {
                return (Promise.resolve(""));
            }
        }
        catch (pError) {
            return (Promise.resolve(""));
        }
        return (Promise.resolve(""));
    }
    static async loadFromContainer_sceneOBX(pContainer) {
        try {
            if (pContainer == null) {
                throw new Error(ERR_INVALID_ARGUMENT);
            }
            let tFiles = await pContainer.listFiles();
            try {
                let tcatFile = "com/scene.obx"; //"structure.xml";
                if (contains(tFiles, tcatFile)) {
                    let t_cat = await pContainer.getFile(tcatFile, false);
                    console.log(tcatFile + " loaded!");
                    return (Promise.resolve(t_cat));
                }
            }
            catch (error) {
                return (Promise.resolve(""));
            }
        }
        catch (pError) {
            return (Promise.resolve(""));
        }
        return (Promise.resolve(""));
    }
    static async loadFromContainer_structureXML(pContainer) {
        try {
            if (pContainer == null) {
                throw new Error(ERR_INVALID_ARGUMENT);
            }
            let tFiles = await pContainer.listFiles();
            try {
                let tcatFile = "structure.xml"; //"structure.xml";
                if (contains(tFiles, tcatFile)) {
                    let t_cat = await pContainer.getFile(tcatFile, false);
                    console.log(tcatFile + " loaded!");
                    return (Promise.resolve(t_cat));
                }
            }
            catch (error) {
                return (Promise.resolve(""));
            }
        }
        catch (pError) {
            return (Promise.resolve(""));
        }
        return (Promise.resolve(""));
    }
    /**
     *<pre>
     * Imports the OPL EOX from URL
     *</pre>
     */
    // tslint:disable-next-line:cyclomatic-complexity
    static async importOPL_EOX_fromURL(pRoomManger, pURL, pEaiwsSession) {
        this.mRoomManager = pRoomManger;
        this.mEaiwsSession = pEaiwsSession;
        this.mimportedWalls = new Array();
        this.mimportedRoomElements = new Array();
        this.mimportedArticleObjects = new Array();
        this.mexistingElements = new Array();
        let tFile = await downloadContent(pURL);
        if (tFile == null)
            return (Promise.reject(false));
        let timportOPL = this.getStructurefromZIP(pRoomManger, tFile, pEaiwsSession);
        return (timportOPL);
    }
    /**
     *<pre>
     * Imports the meta.XML (global settings)
     *</pre>
     */
    // tslint:disable-next-line:cyclomatic-complexity
    static importMetaXML(pRoomManger, pMetaXML) {
        this.mRoomManager = pRoomManger;
        this.mMetaXML = pMetaXML;
        this.mimportedOFMLArticles = new Array();
        this.parseMetaXML();
    }
    /**
     *<pre>
     * Imports the room structor of an EOX structure XML (OPL Flash planner)
     *</pre>
     */
    // tslint:disable-next-line:cyclomatic-complexity
    static async importRoomPlanning(pRoomManger, pStructureXML, pEaiwsSession) {
        this.mRoomManager = pRoomManger;
        this.mEaiwsSession = pEaiwsSession;
        this.mStructureXML = pStructureXML;
        this.mimportedWalls = new Array();
        this.mimportedRoomElements = new Array();
        this.mimportedArticleObjects = new Array();
        this.mexistingElements = new Array();
        this.parseStructureXML();
        let tmaxBounds = this.getMaxBounds();
        let tBBcenter = tmaxBounds.getCenter();
        let tcenterOffset = tBBcenter.subtract(Vector3.Zero());
        tcenterOffset.y = 0;
        this.centerWalls(tcenterOffset);
        this.centerRoomElements(tcenterOffset);
        this.createWalls();
        this.mRoomManager.app.viewer.forceRenderFrame();
        await this.createOpenings();
        this.createRoomElements();
        this.createOFMLObjects(tcenterOffset).then(() => {
            alert("Import finished!");
        });
    }
    /**
     *<pre>
     * Imports the regarding OFML article of scene.obx
     *</pre>
     */
    // tslint:disable-next-line:cyclomatic-complexity
    static importSceneOBX(pRoomManger, pSceneOBX) {
        this.mRoomManager = pRoomManger;
        this.mSceneOBX = pSceneOBX;
        this.mimportedOFMLArticles = new Array();
        this.parseSceneOBX();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static async loadMatchingTable(pRoomManger) {
        if (this.mReplaceArray == null)
            this.mReplaceArray = new Map();
        let tProjectId = Util.HashString(pRoomManger.ProjectId.toLocaleLowerCase().trim());
        let tJsonData = await this._loadJSON(pRoomManger.dataPath + "matchingTable/" + tProjectId + ".json");
        if (tJsonData == null)
            return (Promise.reject(false));
        let tJSstr = JSON.stringify(tJsonData);
        let tJSobj = JSON.parse(tJSstr);
        if (!tJSobj.hasOwnProperty("matchingGroup"))
            return (Promise.reject(false));
        for (let tkeyCategory of tJSobj["matchingGroup"]) {
            if (!tkeyCategory.hasOwnProperty("BAN") ||
                !tkeyCategory.hasOwnProperty("replace"))
                continue;
            let tBAN = tkeyCategory["BAN"];
            let treplaceStr = tkeyCategory["replace"];
            let tmatchTable = {};
            if (tkeyCategory.hasOwnProperty("NEWBAN"))
                tmatchTable.newBAN = tkeyCategory["NEWBAN"];
            if (tkeyCategory.hasOwnProperty("MANID"))
                tmatchTable.MANID = tkeyCategory["MANID"];
            if (tkeyCategory.hasOwnProperty("SERIESID"))
                tmatchTable.SERIESID = tkeyCategory["SERIESID"];
            if (tkeyCategory.hasOwnProperty("insertOffset"))
                tmatchTable.insertOffset = tkeyCategory["insertOffset"];
            let tarrReplace = new Array();
            for (let tTrans of treplaceStr) {
                if (tTrans.hasOwnProperty("old") &&
                    tTrans.hasOwnProperty("new")) {
                    let tarrStrRpl = {};
                    tarrStrRpl.old = tTrans["old"];
                    tarrStrRpl.new = tTrans["new"];
                    tarrReplace.push(tarrStrRpl);
                }
            }
            tmatchTable.matchingReplace = tarrReplace;
            this.mReplaceArray.set(tBAN, tmatchTable);
        }
        return (Promise.resolve(true));
    }
    static async _loadJSON(pURL) {
        try {
            return await ajax("GET", pURL + "?v=" + (100000 * Math.random()).toFixed());
        }
        catch (e) {
            console.log('No JSON was found!');
        }
        finally {
            //...
        }
        return Promise.resolve(null);
    }
    static checkForReplace(pBAN, pvariantCode) {
        let tRes = pvariantCode;
        //check specific BAN
        let tHitspecific = this.mReplaceArray.get(pBAN);
        if (tHitspecific == null)
            return (tRes);
        tHitspecific.matchingReplace.forEach((treplaceArr) => {
            tRes = tRes.split(treplaceArr.old).join(treplaceArr.new);
        });
        //check global replacements
        let tHitglobal = this.mReplaceArray.get("##global##");
        if (tHitglobal == null)
            return (tRes);
        tHitglobal.matchingReplace.forEach((treplaceArr) => {
            let tregEx = new RegExp(treplaceArr.old);
            tRes = tRes.replace(tregEx, treplaceArr.new);
        });
        return (tRes);
    }
    static checkForNewBAN(pBAN) {
        let tRes = pBAN;
        //check specific BAN
        let tHitspecific = this.mReplaceArray.get(pBAN);
        if (tHitspecific == null)
            return (tRes);
        if (tHitspecific.newBAN != null && tHitspecific.newBAN.trim() != "")
            return (tHitspecific.newBAN);
        return (tRes);
    }
    static checkForEAS(pBAN, pOFMLarticle) {
        //check for OFML replacement
        let tHitspecific = this.mReplaceArray.get("EAS__" + pBAN);
        if (tHitspecific == null)
            return;
        if (tHitspecific.newBAN != null && tHitspecific.newBAN.trim() != "" &&
            tHitspecific.MANID != null && tHitspecific.MANID.trim() != "" &&
            tHitspecific.SERIESID != null && tHitspecific.SERIESID.trim() != "") {
            pOFMLarticle.baseAN = tHitspecific.newBAN;
            pOFMLarticle.manufacturerId = tHitspecific.MANID;
            pOFMLarticle.seriesId = tHitspecific.SERIESID;
            if (tHitspecific.insertOffset != null)
                pOFMLarticle.insertOffset = tHitspecific.insertOffset;
            return;
        }
    }
    static checkForNewMAN(pMAN) {
        let tRes = pMAN;
        //check specific BAN
        let tHitspecific = this.mReplaceArray.get("__#" + pMAN.toLocaleUpperCase() + "#__");
        if (tHitspecific == null)
            return (tRes);
        if (tHitspecific.newBAN != null && tHitspecific.newBAN.trim() != "")
            return (tHitspecific.newBAN);
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static parseStructureXML() {
        if (!window.DOMParser || this.mStructureXML == null)
            return;
        let tParser = new DOMParser();
        let txml_STRUCTURE = null;
        txml_STRUCTURE = tParser.parseFromString(this.mStructureXML, "text/xml");
        if (txml_STRUCTURE == null)
            return;
        let teoxObjects = txml_STRUCTURE.getElementsByTagName("eox_object");
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < teoxObjects.length; i++) {
            let tNode = teoxObjects[i];
            if (!tNode.hasAttribute("type") && !tNode.hasAttribute("i_policy"))
                continue;
            let tType = tNode.getAttribute("type");
            let tPolicy = tNode.getAttribute("i_policy");
            if (tType != null && (tType.toLocaleLowerCase() === "eox::wall") &&
                tPolicy != null && (tPolicy.toLocaleLowerCase() === "always")) {
                this.parseWallNode(tNode);
            }
            if (tType != null && (tType.toLocaleLowerCase() === "eox::column") &&
                tPolicy != null && (tPolicy.toLocaleLowerCase() === "always")) {
                this.parseRoomElementNode(tNode);
            }
            if (tType != null && (tType.toLocaleLowerCase() === "eox::object") &&
                tPolicy != null && (tPolicy.toLocaleLowerCase() === "always")) {
                this.parseObjectNode(tNode);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static parseMetaXML() {
        if (!window.DOMParser || this.mMetaXML == null)
            return;
        let tParser = new DOMParser();
        let tMetaXML = null;
        tMetaXML = tParser.parseFromString(this.mMetaXML, "text/xml");
        if (tMetaXML == null)
            return;
        let tadditional_app_data = tMetaXML.getElementsByTagName("additional_app_data");
        if (tadditional_app_data == null || tadditional_app_data.length == 0)
            return;
        if (!tadditional_app_data[0].hasChildNodes)
            return;
        let tapplication_id = tadditional_app_data[0].getElementsByTagName("application_id");
        if (tapplication_id == null || tapplication_id.length == 0)
            return;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tapplication_id[0].childNodes.length; i++) {
            let tchild = tapplication_id[0].children[i];
            if (tchild.nodeName.trim().toLocaleLowerCase() !== "key_value_pair")
                continue;
            if (!tchild.hasAttribute("key") || !tchild.hasAttribute("value"))
                continue;
            let tKey = tchild.getAttribute("key");
            let tValue = tchild.getAttribute("value");
            if (tKey == null || tValue == null)
                continue;
            if (tKey.trim().toLocaleLowerCase() == "wallcolor") {
                let tcolor = parseInt(tValue.trim().toLocaleLowerCase(), 10);
                if (!isNaN(tcolor))
                    this.mWallColor = "#" + tcolor.toString(16);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static parseSceneOBX() {
        if (!window.DOMParser || this.mSceneOBX == null)
            return;
        let tParser = new DOMParser();
        let tSceneOBX = null;
        tSceneOBX = tParser.parseFromString(this.mSceneOBX, "text/xml");
        if (tSceneOBX == null)
            return;
        let tbskArticles = tSceneOBX.getElementsByTagName("bskArticle");
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tbskArticles.length; i++) {
            let tNode = tbskArticles[i];
            if (!tNode.hasAttribute("basketId") && !tNode.hasAttribute("itemType"))
                continue;
            let tbasketId = tNode.getAttribute("basketId");
            let titemType = tNode.getAttribute("itemType");
            if (tbasketId != null && (tbasketId.trim() != "") &&
                titemType != null && (titemType.trim().toLocaleLowerCase() === "basketarticle")) {
                this.parseBasketArticle(tNode, tbasketId, titemType);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static parseBasketArticle(pNode, pbasketId, pitemType) {
        let tOFMLArticle = {};
        tOFMLArticle.basketId = pbasketId;
        tOFMLArticle.itemType = pitemType;
        let tchildNodes = pNode.childNodes;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildNodes.length; i++) {
            let tchild = tchildNodes[i];
            if (tchild.nodeName.toLocaleLowerCase() === "manufacturer") {
                if (!tchild.hasAttribute("id"))
                    continue;
                let tvalue = tchild.getAttribute("id");
                tOFMLArticle.manufacturerId = (tvalue != null && (tvalue === null || tvalue === void 0 ? void 0 : tvalue.trim()) != "") ? tvalue.trim() : undefined;
                continue;
            }
            if (tchild.nodeName.toLocaleLowerCase() === "series") {
                if (!tchild.hasAttribute("id"))
                    continue;
                let tvalue = tchild.getAttribute("id");
                tOFMLArticle.seriesId = (tvalue != null && tvalue.trim() != "") ? tvalue.trim() : undefined;
                continue;
            }
            if (tchild.nodeName.toLocaleLowerCase() === "artnr") {
                if (!tchild.hasAttribute("type"))
                    continue;
                let tAttrValue = tchild.getAttribute("type");
                if (tAttrValue != null && tAttrValue.trim() != "") {
                    let tchildValue = tchild.textContent;
                    tAttrValue = tAttrValue.trim().toLocaleLowerCase();
                    if (tchildValue == null || tchildValue.trim() == "")
                        continue;
                    switch (tAttrValue) {
                        case "base":
                            tOFMLArticle.baseAN = tchildValue.trim();
                            break;
                        case "final":
                            tOFMLArticle.finalAN = tchildValue.trim();
                            break;
                        case "varcode":
                            tOFMLArticle.varcode = tchildValue.trim();
                            break;
                        default:
                            break;
                    }
                }
            }
            if (tOFMLArticle.baseAN != null && tOFMLArticle.baseAN != "")
                this.checkForEAS(tOFMLArticle.baseAN, tOFMLArticle);
            if (tOFMLArticle.basketId != null &&
                tOFMLArticle.manufacturerId != null &&
                tOFMLArticle.seriesId != null &&
                tOFMLArticle.baseAN != null &&
                tOFMLArticle.finalAN != null &&
                tOFMLArticle.varcode != null &&
                tOFMLArticle.itemType != null)
                break;
        }
        if (tOFMLArticle.basketId != null &&
            tOFMLArticle.itemType != null &&
            tOFMLArticle.manufacturerId != null &&
            tOFMLArticle.seriesId != null &&
            (tOFMLArticle.baseAN != null || tOFMLArticle.finalAN == "text")) {
            if (tOFMLArticle.baseAN == null && tOFMLArticle.finalAN != null && tOFMLArticle.finalAN != "") {
                tOFMLArticle.baseAN = tOFMLArticle.finalAN;
            }
            this.mimportedOFMLArticles.push(tOFMLArticle);
        }
    }
    static parseWallNode(pNode) {
        let tWall = this.getOPLWallData(pNode);
        if (tWall == null)
            return;
        let tv1 = new Vector3(0, 0, 0);
        let tv2 = new Vector3(tWall.width, 0, 0);
        let tstart = Util.matMultVec(tWall.matrix, tv1);
        let tend = Util.matMultVec(tWall.matrix, tv2);
        let tWallData = {};
        tWallData.Start = tstart.clone();
        tWallData.End = tend.clone();
        tWallData.Thickness = tWall.depth;
        tWallData.Height = tWall.height;
        tWallData.Length = tWall.width;
        tWallData.Elements = new Array();
        tWallData.createdWall = null;
        this.checkWallElements(pNode, tWallData);
        // first: collect all walls
        // second: get offset to center structure
        this.mimportedWalls.push(tWallData);
    }
    static getImportedOFMLArticle(pbasketId) {
        let tRes;
        for (let tOFMLArticle of this.mimportedOFMLArticles) {
            if (tOFMLArticle.basketId == null)
                continue;
            if (pbasketId.trim().toLocaleLowerCase() == tOFMLArticle.basketId.trim().toLocaleLowerCase()) {
                tRes = tOFMLArticle;
                return (tRes);
            }
        }
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static parseObjectNode(pNode) {
        let tchildNodes = pNode.childNodes;
        let tMatrix = null;
        let tcomLink = null;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildNodes.length; i++) {
            let tchild = tchildNodes[i];
            if (tchild.nodeName.toLocaleLowerCase() === "matrix") {
                if (!tchild.hasAttribute("V"))
                    continue;
                let tvalue = tchild.getAttribute("V");
                tMatrix = (tvalue != null && (tvalue === null || tvalue === void 0 ? void 0 : tvalue.trim()) != "") ? tvalue.trim() : null;
                continue;
            }
            if (tchild.nodeName.toLocaleLowerCase() === "com_link") {
                if (!tchild.hasAttribute("V"))
                    continue;
                let tvalue = tchild.getAttribute("V");
                tcomLink = (tvalue != null && (tvalue === null || tvalue === void 0 ? void 0 : tvalue.trim()) != "") ? tvalue.trim() : null;
                continue;
            }
            if (tMatrix != null && tcomLink != null)
                break;
        }
        if (tcomLink == null || tMatrix == null)
            return;
        let tArtObject = {};
        tMatrix = tMatrix.replace('[', '').replace(']', '');
        let tstrArray = tMatrix.split(",").map(Number);
        tArtObject.matrix = Matrix.FromArray(tstrArray);
        tArtObject.com_link = tcomLink;
        this.mimportedArticleObjects.push(tArtObject);
    }
    static parseRoomElementNode(pNode) {
        let tRoomElement = this.getOPLRoomElementData(pNode);
        if (tRoomElement == null)
            return;
        this.mimportedRoomElements.push(tRoomElement);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static getOPLWallData(pWallNode) {
        let tRes = null;
        let tchildNodes = pWallNode.childNodes;
        let tMatrix = "";
        let tWidth = "";
        let tDepth = "";
        let tHeight = "";
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildNodes.length; i++) {
            let tentry = tchildNodes[i];
            if (tentry.nodeName.toLocaleLowerCase() === "matrix") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tMatrix = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "width") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tWidth = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "depth") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tDepth = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "height") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tHeight = tentry.getAttribute("V");
                continue;
            }
        }
        if (tMatrix == null || tWidth == null || tDepth == null || tHeight == null)
            return (tRes);
        tMatrix = tMatrix.replace('[', '').replace(']', '');
        tRes = {};
        let tstrArray = tMatrix.split(",").map(Number);
        tRes.matrix = Matrix.FromArray(tstrArray);
        tRes.width = parseFloat(tWidth);
        tRes.depth = parseFloat(tDepth);
        tRes.height = parseFloat(tHeight);
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static getOPLRoomElementData(pWallNode) {
        let tRes = null;
        let tchildNodes = pWallNode.childNodes;
        let tMatrix = "";
        let tType = "";
        let tColor = "";
        let tWidth = "";
        let tDepth = "";
        let tHeight = "";
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildNodes.length; i++) {
            let tentry = tchildNodes[i];
            if (tentry.nodeName.toLocaleLowerCase() === "matrix") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tMatrix = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "type") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tType = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "width") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tWidth = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "depth") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tDepth = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "height") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tHeight = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "color") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tColor = tentry.getAttribute("V");
                continue;
            }
        }
        if (tMatrix == null || tWidth == null || tDepth == null || tHeight == null || tColor == null)
            return (tRes);
        tMatrix = tMatrix.replace('[', '').replace(']', '');
        tRes = {};
        let tstrArray = tMatrix.split(",").map(Number);
        tRes.Matrix = Matrix.FromArray(tstrArray);
        tRes.Width = parseFloat(tWidth);
        tRes.Depth = parseFloat(tDepth);
        tRes.Height = parseFloat(tHeight);
        let ttmpColor = parseInt(tColor, 10);
        tRes.Color = "#" + ttmpColor.toString(16);
        if (tType === "1")
            tRes.Type = "PillarC";
        if (tType === "2")
            tRes.Type = "PillarB";
        let tv1 = new Vector3(0, 0, 0);
        let tv2 = new Vector3(tRes.Width, 0, 0);
        let tstart = Util.matMultVec(tRes.Matrix, tv1);
        let tend = Util.matMultVec(tRes.Matrix, tv2);
        tRes.Start = tstart.clone();
        tRes.End = tend.clone();
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static getOPLWallElementData(pWallNode, pType, pPolicy) {
        let tRes = null;
        let tchildNodes = pWallNode.childNodes;
        let tMatrix = null;
        let tWidth = null;
        let tHeight = null;
        let tOrientation = null;
        let tAlignment = null;
        let tParapetHeight = null;
        let tSections = null;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildNodes.length; i++) {
            let tentry = tchildNodes[i];
            if (tentry.nodeName.toLocaleLowerCase() === "matrix") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tMatrix = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "width") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tWidth = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "height") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tHeight = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "orientation") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tOrientation = (tentry.getAttribute("V")).toLocaleLowerCase();
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "alignment") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tAlignment = (tentry.getAttribute("V")).toLocaleLowerCase();
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "parapetheight") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tParapetHeight = tentry.getAttribute("V");
                continue;
            }
            if (tentry.nodeName.toLocaleLowerCase() === "sections") {
                if (!tentry.hasAttribute("V"))
                    continue;
                tSections = tentry.getAttribute("V");
                continue;
            }
        }
        if (tMatrix == null || tWidth == null || tHeight == null)
            return (tRes);
        tMatrix = tMatrix.replace('[', '').replace(']', '');
        tRes = {};
        switch (pType) {
            case "Alley":
                tRes.Type = "Opening";
                break;
            case "glasspanel":
                tRes.Type = "GlassFront";
                break;
            case "glassdoor":
                tRes.Type = "GlassDoor";
                break;
            case "soliddoor":
                tRes.Type = "Door";
                break;
            case "solidddoor":
                tRes.Type = "DoubleDoor";
                break;
            case "window":
                tRes.Type = "Window";
                break;
            case "dwindow":
                tRes.Type = "WindowDouble";
                break;
            case "radiator":
                tRes.Type = "Radiator";
                break;
            default:
                tRes.Type = "Opening";
                break;
        }
        let tstrArray = tMatrix.split(",").map(Number);
        tRes.Matrix = Matrix.FromArray(tstrArray);
        tRes.Length = parseFloat(tWidth);
        tRes.Height = parseFloat(tHeight);
        let tv1 = new Vector3(0, 0, 0);
        let tv2 = new Vector3(tRes.Length, 0, 0);
        let tstart = Util.matMultVec(tRes.Matrix, tv1);
        let tend = Util.matMultVec(tRes.Matrix, tv2);
        tRes.Start = tstart.clone();
        tRes.End = tend.clone();
        if (tOrientation != null) {
            tRes.Orientation = tOrientation == "inside" ? Orientation.inside : Orientation.outside;
        }
        else {
            tRes.Orientation = null;
        }
        if (tAlignment != null) {
            tRes.Alignment = tAlignment == "r" ? Alignment.right : Alignment.left;
        }
        else {
            tRes.Alignment = null;
        }
        if (tSections != null) {
            tRes.Sections = parseFloat(tSections);
        }
        else {
            tRes.Sections = null;
        }
        if (tParapetHeight != null) {
            tRes.ParapetHeight = parseFloat(tParapetHeight);
        }
        else {
            tRes.ParapetHeight = null;
        }
        return (tRes);
    }
    static getMaxBounds() {
        let tBoundsAll = new BoundingBox();
        for (let tWallData of this.mimportedWalls) {
            let tBounds = new BoundingBox();
            let tStart = tWallData.Start;
            let tEnd = tWallData.End;
            tEnd.y = tWallData.Height;
            if (tWallData.Start.x < tWallData.End.x) {
                tBounds = new BoundingBox(tWallData.Start, tWallData.End);
            }
            else {
                tBounds = new BoundingBox(tWallData.End, tWallData.Start);
            }
            tBoundsAll = tBoundsAll.expand(tBounds);
        }
        if (this.mimportedWalls.length > 0)
            return (tBoundsAll);
        for (let tREData of this.mimportedRoomElements) {
            let tBounds = new BoundingBox();
            let tStart = tREData.Start;
            let tEnd = tREData.End;
            tEnd.y = tREData.Height;
            if (tStart.x < tEnd.x) {
                tBounds = new BoundingBox(tStart, tEnd);
            }
            else {
                tBounds = new BoundingBox(tEnd, tStart);
            }
            tBoundsAll = tBoundsAll.expand(tBounds);
        }
        return (tBoundsAll);
    }
    static centerWalls(pOffset) {
        for (let tWallData of this.mimportedWalls) {
            tWallData.Start.subtractInPlace(pOffset);
            tWallData.End.subtractInPlace(pOffset);
        }
    }
    static centerRoomElements(pOffset) {
        for (let tREData of this.mimportedRoomElements) {
            tREData.Start.subtractInPlace(pOffset);
            tREData.End.subtractInPlace(pOffset);
        }
    }
    static createWalls() {
        this.mRoomManager.beginCollectWallUpdates();
        for (let tWallData of this.mimportedWalls) {
            let tWallA = RoomWizard.createWall(this.mRoomManager, tWallData.Height, tWallData.Thickness);
            tWallData.createdWall = tWallA;
            tWallA.setStartPoint(Util.to2d(tWallData.Start));
            tWallA.setEndPoint(Util.to2d(tWallData.End));
            this.mRoomManager.createColorMaterial(this.mWallColor);
            tWallA.materialSetA.category = "color";
            tWallA.materialSetA.value = this.mWallColor;
            tWallA.materialSetB.category = "color";
            tWallA.materialSetB.value = this.mWallColor;
            tWallA.setDrawingNew(false);
        }
        this.mRoomManager.app.viewer.requestRenderFrame();
        this.mRoomManager.endCollectWallUpdates(true);
        this.mRoomManager._findWallsConnection();
    }
    static createRoomElements() {
        for (let tREData of this.mimportedRoomElements) {
            this.mRoomManager.insertRoomElement(tREData.Type).then((pRoomElement) => {
                if (pRoomElement != null) {
                    let tPos = Vector3.Center(tREData.Start, tREData.End);
                    if (tREData.Type === "PillarB") {
                        pRoomElement.setWidth(tREData.Width, false, true);
                        pRoomElement.setDepth(tREData.Depth, false, true);
                        //tPos.x -= tREData.Width * 0.5;
                        tPos.z -= tREData.Depth * 0.5;
                    }
                    if (tREData.Type === "PillarC") {
                        pRoomElement.setWidth(tREData.Width, false, true);
                        //tPos.z -= tREData.Depth * 0.5;
                        tPos.x -= tREData.Width * 0.5;
                    }
                    let tMaterialSet = pRoomElement.materialSet;
                    tMaterialSet.value = tREData.Color;
                    pRoomElement.setMaterialSet(tMaterialSet);
                    pRoomElement.setHeight(tREData.Height, true);
                    pRoomElement.setPosition(tPos, false);
                }
            });
        }
        this.mRoomManager.app.viewer.requestRenderFrame();
    }
    static getElement(pbasketId) {
        let tRes = null;
        for (let tentry of this.mexistingElements) {
            if (pbasketId == tentry.basketId) {
                tRes = tentry;
                break;
            }
        }
        return (tRes);
    }
    static getNodeBoundsOffset(pElement) {
        let tRes = Vector3.Zero();
        let tnodePos = pElement.node.position.clone();
        let tBB = pElement.boundingBoxVisible.clone();
        let tWM = pElement.node.getWorldMatrix();
        let tBBcenter = tBB.getCenter();
        tBBcenter.y = tnodePos.y;
        tBBcenter = Vector3.TransformCoordinates(tBB.getCenter(), tWM).clone();
        tRes = tBBcenter.subtract(tnodePos);
        tRes.y = 0;
        return (tRes);
    }
    static getNodeBoundCenter(pElement) {
        let tRes = Vector3.Zero();
        let tnodePos = pElement.node.position.clone();
        let tBB = pElement.boundingBoxVisible.clone();
        let tWM = pElement.node.getWorldMatrix();
        let tBBcenter = tBB.getCenter();
        tBBcenter.y = tnodePos.y;
        tBBcenter = Vector3.TransformCoordinates(tBB.getCenter(), tWM).clone();
        tRes = tBBcenter;
        return (tRes);
    }
    static sortImportList() {
        let tTextElements = new Array();
        for (let tArticle of this.mimportedArticleObjects) {
            if (tArticle.com_link == null || tArticle.matrix == null)
                continue;
            let timportedOFMLArticle = this.getImportedOFMLArticle(tArticle.com_link);
            if (timportedOFMLArticle == null ||
                (timportedOFMLArticle.manufacturerId == null || timportedOFMLArticle.baseAN == null))
                continue;
            // text element
            if (timportedOFMLArticle.manufacturerId == "text" && timportedOFMLArticle.seriesId == "text") {
                tTextElements.push(tArticle);
            }
        }
        for (let tArticle of tTextElements) {
            removeElement(this.mimportedArticleObjects, tArticle);
        }
        addElements(this.mimportedArticleObjects, tTextElements);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static async createOFMLObjects(pOffset) {
        let tSearchSet = new SearchArticleParameterSet();
        let tdebugCount = 0;
        let tOffset = pOffset.clone();
        this.sortImportList();
        for (let tArticle of this.mimportedArticleObjects) {
            // if (tdebugCount > 10)
            //     break;
            if (tArticle.com_link == null || tArticle.matrix == null)
                continue;
            let timportedOFMLArticle = this.getImportedOFMLArticle(tArticle.com_link);
            if (timportedOFMLArticle == null ||
                (timportedOFMLArticle.manufacturerId == null || timportedOFMLArticle.baseAN == null))
                continue;
            // text element
            if (timportedOFMLArticle.manufacturerId == "text" && timportedOFMLArticle.seriesId == "text") {
                this.createTextElement(tArticle, timportedOFMLArticle, tOffset);
                continue;
            }
            let tmanID = this.checkForNewMAN(timportedOFMLArticle.manufacturerId);
            tSearchSet.baseArticleNumber = this.checkForNewBAN(timportedOFMLArticle.baseAN);
            tSearchSet.manufacturerId = tmanID;
            let treplVarCode = "";
            if (timportedOFMLArticle.varcode != null) {
                treplVarCode = this.checkForReplace(timportedOFMLArticle.baseAN, timportedOFMLArticle.varcode);
            }
            tSearchSet.variantCode = treplVarCode;
            tSearchSet.varCodeType = "OFML";
            if (this.mEaiwsSession == null)
                return;
            let texElement = this.getElement(tArticle.com_link);
            let tv1 = new Vector3(0, 0, 0);
            let tv2 = new Vector3(1, 0, 0);
            let tPos = Util.matMultVec(tArticle.matrix, tv1);
            // general offset to center planning
            let tAnglePnt = Util.matMultVec(tArticle.matrix, tv2).subtract(tPos);
            let tAngle = Math.atan2(-tAnglePnt.z, tAnglePnt.x);
            tPos.y = tArticle.matrix.m[7];
            tPos.z = -tPos.z;
            if (timportedOFMLArticle.insertOffset != null) {
                tPos.y = timportedOFMLArticle.insertOffset;
            }
            // element exists allready; clone it!
            if (texElement != null) {
                let tclone = texElement.element.clone();
                if (tclone == null)
                    continue;
                //reset origin rotation
                tclone.node.rotateAround(this.getNodeBoundCenter(tclone), VECTOR3_Y, -texElement.rotationAngle);
                tclone.updateTransformation();
                let tInsertCommand = new InsertElements(this.mRoomManager.app, [tclone]);
                let texecuted = await this.mRoomManager.app.commands.executeCommand(tInsertCommand);
                if (texecuted) {
                    let tnodeBBoffset = this.getNodeBoundsOffset(tclone);
                    let tfinalPos = tPos;
                    tfinalPos.subtractInPlace(pOffset);
                    tfinalPos.subtractInPlace(tnodeBBoffset);
                    tclone.node.position = tfinalPos;
                    tclone.updateTransformation();
                    tclone.node.rotateAround(this.getNodeBoundCenter(tclone), VECTOR3_Y, tAngle);
                    tclone.updateTransformation();
                    tdebugCount++;
                    continue;
                }
            }
            let tcatItems = await this.mEaiwsSession.catalog.searchArticle(tSearchSet);
            if (tcatItems != null && tcatItems.totalHits > 0) {
                let tfoundItem = tcatItems.scoredItems[0].item;
                if (timportedOFMLArticle.varcode != null)
                    tfoundItem.variantCode = treplVarCode;
                let tElement = await this.mRoomManager.articleManager.insertArticle(tfoundItem);
                if (tElement != null) {
                    // add new created element to the list of existing elements
                    let tnewElement = {};
                    tnewElement.basketId = tArticle.com_link;
                    tnewElement.element = tElement;
                    tnewElement.rotationAngle = tAngle;
                    this.mexistingElements.push(tnewElement);
                    let tInsertCommand = new InsertElements(this.mRoomManager.app, [tElement]);
                    let texecuted = await this.mRoomManager.app.commands.executeCommand(tInsertCommand);
                    if (texecuted) {
                        let tnodeBBoffset = this.getNodeBoundsOffset(tElement);
                        let tfinalPos = tPos;
                        tfinalPos.subtractInPlace(pOffset);
                        tfinalPos.subtractInPlace(tnodeBBoffset);
                        tElement.node.position = tfinalPos;
                        tElement.updateTransformation();
                        tElement.node.rotateAround(this.getNodeBoundCenter(tElement), VECTOR3_Y, tAngle);
                        tElement.updateTransformation();
                        tdebugCount++;
                        continue;
                    }
                }
            }
        }
        this.mRoomManager.app.viewer.requestRenderFrame();
    }
    static getTextVarCodeValues(pVarCode) {
        let tRes = null;
        let tText = "";
        let tSize = 0.19;
        let tvarSplit = pVarCode.split(";");
        if (tvarSplit.length < 2)
            return (tRes);
        for (let tEntry of tvarSplit) {
            let tKVsplit = tEntry.split("=");
            if (tKVsplit.length < 2)
                continue;
            if (tKVsplit[0].trim().toLocaleLowerCase() == "text")
                tText = tKVsplit[1].trim();
            if (tKVsplit[0].trim().toLocaleLowerCase() == "size") {
                let tSize1 = parseFloat("0." + tKVsplit[1].trim());
                if (!isNaN(tSize1))
                    tSize = tSize1 + 0.05;
            }
        }
        if (tText != "") {
            tRes = {};
            tRes.text = tText;
            tRes.size = tSize;
            return (tRes);
        }
        return (tRes);
    }
    static createTextElement(pArticleObj, pOFMLArticle, pOffset) {
        if (pOFMLArticle.varcode == null || pOFMLArticle.varcode == "" || pArticleObj.matrix == null)
            return (Promise.resolve(false));
        let tTextData = this.getTextVarCodeValues(pOFMLArticle.varcode);
        if (tTextData == null)
            return (Promise.resolve(false));
        let tPromise = this.mRoomManager.insertRoomElement("Text").then((pRoomElement) => {
            if (pRoomElement != null) {
                let ttmpText = tTextData.text;
                ttmpText = ttmpText.split("%0D").join("\n");
                pRoomElement.setText(unescape(ttmpText), false);
                pRoomElement.setTextHeight(tTextData.size, false);
                let tv1 = new Vector3(0, 0, 0);
                let tv2 = new Vector3(1, 0, 0);
                let tPos = Util.matMultVec(pArticleObj.matrix, tv1);
                // general offset to center planning
                let tAnglePnt = Util.matMultVec(pArticleObj.matrix, tv2).subtract(tPos);
                let tAngle = Math.atan2(-tAnglePnt.z, tAnglePnt.x);
                tPos.y = pArticleObj.matrix.m[7];
                tPos.z = -tPos.z;
                tPos = tPos.subtract(pOffset);
                //tPos.z += 0.1;
                pRoomElement.setPosition(tPos, false);
                pRoomElement.node.rotateAround(this.getNodeBoundCenter(pRoomElement), VECTOR3_Y, tAngle);
                pRoomElement.updateTransformation();
                pRoomElement.updateGeometry();
                return (Promise.resolve(true));
            }
            return (Promise.resolve(false));
        });
        return (tPromise);
    }
    static _insertWallOpening(pWallData, pWallElement) {
        if (pWallData.createdWall == null)
            return (Promise.resolve(null));
        let twallDir = Util.to3d(pWallData.createdWall.wallDirection);
        let tPos = pWallData.Start.add(twallDir.scale(pWallElement.Length * 0.5 + pWallElement.Start.x));
        let tPromise = this.mRoomManager.insertWallOpening(pWallElement.Type, pWallData.createdWall, tPos).then((pOpening) => {
            if (pOpening == null)
                return (Promise.resolve(null));
            pOpening.setMaterial_Leaf_complete(this.mOpeningMaterial);
            // glassfront: set segment count
            if (pWallElement.Type === "GlassFront" && pWallElement.Sections != null) {
                pOpening.OpeningParams.ColumnCount = Math.trunc(pWallElement.Sections);
                pOpening.OpeningParams.ColumnWidth = pWallElement.Length / pWallElement.Sections;
            }
            // set floor offset
            if (pWallElement.ParapetHeight != null) {
                pOpening.setFloorOffset(pWallElement.ParapetHeight, false);
            }
            // set horizontal mirror
            if (pWallElement.Alignment != null && pWallElement.Alignment == Alignment.left)
                pOpening.setMirrorVertical(true);
            // set vertical mirror
            if (pWallElement.Orientation != null && pWallElement.Orientation == Orientation.outside)
                pOpening.setMirrorHorizontal(true);
            pOpening.setWidth(pWallElement.Length);
            pOpening.setHeight(pWallElement.Height);
            pOpening.setPosition(Util.to2d(tPos));
            if (pOpening.wall != null) {
                pOpening.wall.checkFreeWallSpace(true, new Vector2(0, 0));
            }
            return (Promise.resolve(pOpening));
        });
        return (tPromise);
    }
    static _insertWallAddition(pWallData, pWallElement) {
        if (pWallData.createdWall == null)
            return;
        let twallDir = Util.to3d(pWallData.createdWall.wallDirection);
        let tPos = pWallData.Start.add(twallDir.scale(pWallElement.Length * 0.5 + pWallElement.Start.x));
        this.mRoomManager.insertWallAddition("Radiator", pWallData.createdWall, tPos, pWallElement.Length, pWallElement.Height).then((pAddition) => {
            if (pAddition != null) {
                // set floor offset
                if (pWallElement.ParapetHeight != null) {
                    pAddition.setFloorOffset(pWallElement.ParapetHeight, false);
                }
                // set horizontal mirror
                if (pWallElement.Alignment != null && pWallElement.Alignment == Alignment.left)
                    pAddition.setMirrorVertical(true);
                // set vertical mirror
                if (pWallElement.Orientation != null && pWallElement.Orientation == Orientation.outside)
                    pAddition.setMirrorHorizontal(true);
                pAddition.setWidth(pWallElement.Length);
                pAddition.setHeight(pWallElement.Height);
                pAddition.setPosition(Util.to2d(tPos));
            }
        });
    }
    static async createOpenings() {
        this.mRoomManager.beginCollectWallUpdates();
        for (let tWallData of this.mimportedWalls) {
            if (tWallData.createdWall == null)
                continue;
            for (let tWallElement of tWallData.Elements) {
                let twallDir = Util.to3d(tWallData.createdWall.wallDirection);
                let tPos = tWallData.Start.add(twallDir.scale(tWallElement.Length * 0.5 + tWallElement.Start.x));
                if (tWallElement.Type != "Radiator") {
                    await this._insertWallOpening(tWallData, tWallElement);
                }
                else {
                    this._insertWallAddition(tWallData, tWallElement);
                }
            }
        }
        this.mRoomManager.app.viewer.requestRenderFrame();
        this.mRoomManager.endCollectWallUpdates(true);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static checkWallElements(pNode, pWallData) {
        if (!pNode.hasChildNodes)
            return;
        let tchildElements = pNode.childNodes;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tchildElements.length; i++) {
            let tNode = tchildElements[i];
            if (tNode.nodeName !== "eox_object")
                continue;
            if (!tNode.hasAttribute("type") && !tNode.hasAttribute("i_policy"))
                continue;
            let tType = (tNode.getAttribute("type")).toLocaleLowerCase();
            let tPolicy = (tNode.getAttribute("i_policy")).toLocaleLowerCase();
            tType = tType.replace("eox::", "");
            if (tType == "" || tPolicy == "")
                continue;
            let tWallElement = this.getOPLWallElementData(tNode, tType, tPolicy);
            if (tWallElement == null)
                continue;
            pWallData.Elements.push(tWallElement);
        }
    }
}
OPLeoxImporter.mWallColor = "#ffffff";
export var Orientation;
(function (Orientation) {
    Orientation[Orientation["inside"] = 0] = "inside";
    Orientation[Orientation["outside"] = 1] = "outside";
})(Orientation || (Orientation = {}));
export var Alignment;
(function (Alignment) {
    Alignment[Alignment["right"] = 0] = "right";
    Alignment[Alignment["left"] = 1] = "left";
})(Alignment || (Alignment = {}));
